module.exports = __webpack_public_path__ + "static/media/ic_cover_forgot_pass.5b9fa8c7.png";